import { PriceTemplateManual } from "../../shared/PriceTemplateManualJson";
import { WeekDay } from "../../shared/WeekDay";

export default {
   birthdaysPrices: {
      default: {
         title: "",
         remarks: "",
         cancellationRemarks:
            "Eine Terminänderung ist bis 2 Wochen vor dem Termin möglich. Im Falle einer Terminänderung werden 25€ Bearbeitungsgebühr berechnet. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
      }
   },

   holidaysPrices: {
      default: {
         title: "",
         remarks: "",
         cancellationRemarks:
            "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
      },

      discountPrices: [
         {
            title: "Familienmitgliedschaft",
            remarks:
               "Nur für Familienmitgliedschaften (Die Familienmitgliedschaft kostet 105 Euro/Jahr). Förderungen durch den Arbeitgeber haben Vorrang.",
            cancellationRemarks:
               "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
         },
         {
            title: "Siemens",
            remarks:
               "Förderung möglich, wenn die Kinder eine 1. - 5. Klasse besuchen, beide Eltern müssen berufstätig sein, einer davon bei Siemens. Bitte Siemens-Personalnummer angeben!",
            cancellationRemarks:
               "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
         },
         {
            title: "Siemens Healthineers",
            remarks:
               "Förderung möglich, wenn die Kinder eine 1. - 5. Klasse besuchen, beide Eltern müssen berufstätig sein, einer davon bei Siemens. Bitte Siemens-Personalnummer angeben!",
            cancellationRemarks:
               "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
         },
         {
            title: "Siemens Mobility",
            remarks:
               "Förderung möglich, wenn die Kinder eine 1. - 5. Klasse besuchen, beide Eltern müssen berufstätig sein, einer davon bei Siemens. Bitte Siemens-Personalnummer angeben!",
            cancellationRemarks:
               "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
         },
         {
            title: "Siemens Energy",
            remarks:
               "Förderung möglich, wenn die Kinder eine 1. - 5. Klasse besuchen, beide Eltern müssen berufstätig sein, einer davon bei Siemens. Bitte Siemens-Personalnummer angeben!",
            cancellationRemarks:
               "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
         },
         {
            title: "Erlanger Bündnis für Familien",
            remarks:
               "Förderung möglich, wenn die Kinder eine 1. - 5. Klasse besuchen, in Erlangen wohnen und beide Eltern berufstätig sind.",
            cancellationRemarks:
               "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
         },
         {
            title: "Erlangen Pass",
            remarks:
               "Der Erlangen-Pass ist bei der Stadt Erlangen erhältlich. Bitte senden Sie uns eine Kopie/ein Foto per E-Mail oder legen Sie den Pass am ersten Tag vor.",
            cancellationRemarks:
               "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
         },
         {
            title: "Primetals Technologies Germany",
            remarks:
               "Förderung möglich, wenn die Kinder eine 1. - 5. Klasse besuchen, beide Eltern müssen berufstätig sein, einer davon bei Primetals. Bitte Primetals-Personalnummer angeben!",
            cancellationRemarks:
               "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
         },
      ],

      addonPrices: [
         {
            title: "Frühbetreuung",
            remarks: "Die Frühbetreuung beginnt ab 7:30 Uhr.",
            cancellationRemarks: ""
         }
      ]
   },

   workshopPrices: {
      default: {
         title: "",
         remarks:
            "",
         cancellationRemarks:
            "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
      },

      templates: [
         {
            title: "Normalpreis",
            remarks: "",
            cancellationRemarks:
               "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
         },
         {
            title: "Mitglied",
            remarks: "",
            cancellationRemarks:
               "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
         },
         {
            title: "Gutschein",
            remarks: "",
            cancellationRemarks:
               "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
         },
      ]
   },

   groupsPrices: {
      default: {
         title: "",
         remarks: "",
         cancellationRemarks:
            "Stornierungen 2 Wochen vor dem Termin sind kostenfrei. Ab 2 Woche vor dem Termin werden 50% des Betrages berechnet. Ab 1 Woche vor dem Termin werden 75% des Betrages berechnet. Dies gilt für Stornierungen, die spätestens am Vortag bis 13:00 Uhr bei uns eingehen (für Veranstaltungen von Sa - Mo müssen sie bis Fr 13:00 Uhr eingehen) – danach müssen wir 100% berechnen."
      }
   },

   rental: {
      rentalCondition: [
         {
            title: "pro Tag",
            remarks: "",
            cancellationFee: 1000,
            cancellationRemarks: "",
            rentalDurationStartWeekDay: null,
            rentalDurationDays: 1
         },

         {
            title: "Wochenende",
            remarks: "Donnerstag bis Montag",
            cancellationFee: 1000,
            cancellationRemarks: "",
            rentalDurationStartWeekDay: WeekDay.Thursday,
            rentalDurationDays: 4
         },

         {
            title: "Woche",
            remarks: "Montag bis Freitag.\nBitte beachten Sie, dass wir immer ganze Wochen abrechnen (ggf. kann eine andere Kondition günstiger sein).",
            cancellationFee: 1000,
            cancellationRemarks: "",
            rentalDurationStartWeekDay: null,
            rentalDurationDays: 6
         },
      ],

      additionalRentalCondition: []
   },
} as PriceTemplateManual;